import type { GetLegalDocumentsInput, LegalDocumentCreateDto, LegalDocumentDto, LegalDocumentUpdateDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LegalDocumentService {
  apiName = 'Inventory';

  create = (input: LegalDocumentCreateDto) =>
    this.restService.request<any, LegalDocumentDto>({
      method: 'POST',
      url: '/api/inventory/legal-documents',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/legal-documents/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, LegalDocumentDto>({
      method: 'GET',
      url: `/api/inventory/legal-documents/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetLegalDocumentsInput) =>
    this.restService.request<any, PagedResultDto<LegalDocumentDto>>({
      method: 'GET',
      url: '/api/inventory/legal-documents',
      params: { filterText: input.filterText, description: input.description, expireDateMin: input.expireDateMin, expireDateMax: input.expireDateMax, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: LegalDocumentUpdateDto) =>
    this.restService.request<any, LegalDocumentDto>({
      method: 'PUT',
      url: `/api/inventory/legal-documents/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
